import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUp, faCloudDownloadAlt} from "@fortawesome/free-solid-svg-icons";

import TableWinnerItems from "./TableWinnerItems";

import "./Table.scss";

const PlayerTable = ({deleted, handleDelete, handleTableSort, attendeeList, tableSort}) => {
  
  const clsSort = Object.keys(tableSort).reduce((obj, key) => {
    obj[key] = tableSort[key] ? `is-${tableSort[key]}` : "";
    return obj;
  }, {});

  const list = attendeeList.filter((v)=>v.won);

  if(list.length==0) {
    return <span/>;
  }

  const tableInfoContainer = (
    <div className="table-info-container">
      <div className="form-row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <div className="heading">{list.length} winner{list.length === 1 ? "" : "s"}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="table-section">
      {tableInfoContainer}
      <div className="table-container">
        <table className="table" id="js-table">
          <thead>
            <tr className="table-row table-row-heading d-none d-md-table-row">
              <th className="table-heading" scope="col">
                &nbsp;
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("name")}>
                  Name
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.name}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("company")}>
                  Company
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.company}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">
                <div className="d-flex align-items-center justify-content-left" onClick={() => handleTableSort("email")}>
                  Email
                  <div className="table-sort-btn">
                    <FontAwesomeIcon
                      className={`table-sort-btn-icon ${clsSort.email}`}
                      icon={faArrowUp}
                    />
                  </div>
                </div>
              </th>
              <th className="table-heading" scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <TableWinnerItems
              deleted={deleted}
              handleDelete={handleDelete}
              list={list}
              tableSort={tableSort}
              deleteButtonText="Delete winner"
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlayerTable;
